"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SecureTextField = exports.SecureTextFieldComponent = void 0;
var PropTypes = require("prop-types");
var React = require("react");
var ErrorMessage_1 = require("../ErrorMessage");
var HelpText_1 = require("../HelpText");
/**
 * SecureTextField
 */
var SecureTextFieldComponent = function (props) {
    // Extract known attributes from props into variables
    var className = props.className, // Capture the classname so it cannot be applied to the securetextfield
    children = props.children, errormessage = props.errormessage, forwardRef = props.forwardRef, helptext = props.helptext, id = props.id, isValid = props.isValid, label = props.label, maxLength = props.maxLength, name = props.name, onBlur = props.onBlur, onChange = props.onChange, onFocus = props.onFocus, placeholder = props.placeholder, // Capture the placeholder so it cannot be applied to the securetextfield
    required = props.required, value = props.value, attributes = __rest(props, ["className", "children", "errormessage", "forwardRef", "helptext", "id", "isValid", "label", "maxLength", "name", "onBlur", "onChange", "onFocus", "placeholder", "required", "value"]) // tslint:disable-line
    ;
    // Form items required for update
    var _a = React.useState('show'), buttonText = _a[0], setButtonText = _a[1];
    var _b = React.useState('show password'), inputAriaLabel = _b[0], setInputAriaLabel = _b[1];
    var _c = React.useState('password'), inputType = _c[0], setInputType = _c[1];
    attributes.id = id;
    attributes.className = 'form-control';
    attributes.name = name ? name : id;
    attributes.type = inputType;
    // Add maximum length
    if (typeof maxLength === 'number' && maxLength > 0) {
        attributes.maxLength = maxLength;
    }
    if (typeof onBlur === 'function') {
        attributes.onBlur = onBlur;
    }
    if (typeof onChange === 'function') {
        attributes.value = typeof maxLength === 'undefined'
            ? value
            : String(value).slice(0, maxLength);
        attributes.onChange = function (e) {
            // @ts-ignore
            onChange(attributes.name, e.target.value, e);
        };
    }
    else {
        attributes.defaultValue = typeof maxLength === 'undefined'
            ? value
            : String(value).slice(0, maxLength);
    }
    if (typeof onFocus === 'function') {
        attributes.onFocus = onFocus;
    }
    if (typeof required === 'boolean' && required === true) {
        attributes['aria-required'] = true;
    }
    var ErrorMessageComponent;
    var HelpTextComponent;
    if (typeof isValid === 'boolean' && isValid === false) {
        // Invalid
        attributes.className += ' is-invalid';
        attributes['aria-invalid'] = true;
        // Invalid with error message
        if (errormessage) {
            attributes['aria-describedby'] = id + "-errormessage";
            ErrorMessageComponent = (React.createElement(ErrorMessage_1.ErrorMessage, { id: id, message: errormessage }));
        }
    }
    else if (helptext) {
        attributes['aria-describedby'] = id + "-helptext";
        HelpTextComponent = (React.createElement(HelpText_1.HelpText, { id: id }, helptext));
    }
    // When user clicks on the hide/show button
    var toggleTextPasswordField = function () {
        if (inputType === 'password') {
            setButtonText('hide');
            setInputAriaLabel('hide password');
            setInputType('text');
        }
        else {
            setButtonText('show');
            setInputAriaLabel('show password');
            setInputType('password');
        }
    };
    // Button attributes
    var buttonAttributes = {
        'aria-label': inputAriaLabel,
        className: 'btn-action-formfield',
        onClick: toggleTextPasswordField,
    };
    return (React.createElement("div", { className: "form-group" },
        React.createElement("label", { htmlFor: id }, label),
        React.createElement("div", { className: "form-field__with-btn" },
            React.createElement("input", __assign({}, attributes, { ref: forwardRef })),
            React.createElement("button", __assign({ type: "button" }, buttonAttributes), buttonText),
            HelpTextComponent,
            ErrorMessageComponent)));
};
exports.SecureTextFieldComponent = SecureTextFieldComponent;
exports.SecureTextFieldComponent.defaultProps = {
    isValid: true,
};
exports.SecureTextFieldComponent.displayName = 'SecureTextField';
// tslint:disable no-string-literal
exports.SecureTextFieldComponent['propTypes'] = {
    errormessage: PropTypes.string,
    helptext: PropTypes.string,
    id: PropTypes.string.isRequired,
    isValid: PropTypes.bool,
    label: PropTypes.string.isRequired,
    maxLength: PropTypes.number,
    /* Name will default to ID if not provided. ID is required for linking label with input */
    name: PropTypes.string,
    noPlaceholder: function (props) {
        if (typeof props['placeholder'] !== 'undefined') {
            return new Error('The placeholder attribute is not allowed in Honeycomb');
        }
        return;
    },
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
    onFocus: PropTypes.func,
    required: PropTypes.bool,
    value: PropTypes.string,
};
// tslint:enable no-string-literal
exports.SecureTextField = React.forwardRef(function (props, ref) {
    return (React.createElement(exports.SecureTextFieldComponent, __assign({}, props, { forwardRef: ref })));
});
exports.SecureTextField.displayName = 'SecureTextField';
